const centerStyle = theme => ({
  margin: "0 auto",
  width: "1150px",
  [theme.breakpoints.down("sm")]: {
    padding: "20px",
    width: "auto",
  },
});

export default centerStyle;



// WEBPACK FOOTER //
// ./src/views/LandingPage/partials/center.jsx